import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/common/Layout'
import ProtectedRoute from './components/common/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'
import AnalysisPage from './pages/AnalysisPage'
import AnnotationGuidePage from './pages/AnnotationGuidePage'
import AnnotationReviewPage from './pages/AnnotationReviewPage'
import ChangePasswordPage from './pages/ChangePasswordPage'
import LoginPage from './pages/LoginPage'
import ProjectAnnotationPage from './pages/ProjectAnnotationPage'
import ProjectEditPage from './pages/ProjectEditPage'
import ProjectsPage from './pages/ProjectsPage'
import StatisticsPage from './pages/StatisticsPage'
import UsersPage from './pages/UsersPage'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/projects" replace />} />
                  <Route path="/annotation-guide" element={<AnnotationGuidePage />} />
                  <Route path="/annotation-guide/:keypointName" element={<AnnotationGuidePage />} />
                  <Route path="/projects" element={<ProjectsPage />} />
                  <Route path="/projects/:projectId" element={<ProjectAnnotationPage />} />
                  <Route
                    path="/projects/:projectId/edit"
                    element={
                      <ProtectedRoute requireAdmin>
                        <ProjectEditPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/projects/:projectId/analysis" element={<AnalysisPage />} />
                  <Route
                    path="/projects/:projectId/review"
                    element={
                      <ProtectedRoute requireAdmin>
                        <AnnotationReviewPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <ProtectedRoute requireAdmin>
                        <UsersPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/statistics" element={<StatisticsPage />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
